function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1178_4838)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M55.4898 38.53C55.2298 38.53 54.9598 38.5 54.6998 38.45C52.5298 38.01 51.1298 35.9 51.5698 33.74C51.8598 32.31 51.9998 30.84 51.9998 29.37C51.9998 19.79 45.8798 11.38 36.7698 8.44002C34.6698 7.76002 33.5198 5.51002 34.1898 3.40002C34.8698 1.30002 37.1198 0.150016 39.2298 0.820016C51.6498 4.84002 59.9998 16.31 59.9998 29.37C59.9998 31.37 59.7998 33.37 59.4098 35.32C59.0298 37.22 57.3598 38.53 55.4898 38.53Z",
  fill: "#32D583"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30 59.37C22.46 59.37 15.26 56.56 9.70998 51.46C8.07998 49.96 7.97998 47.43 9.46998 45.81C10.97 44.19 13.5 44.08 15.12 45.57C19.19 49.31 24.47 51.37 30 51.37C35.53 51.37 40.85 49.3 44.92 45.53C46.54 44.03 49.07 44.13 50.57 45.75C52.07 47.37 51.97 49.9 50.35 51.4C44.79 56.54 37.56 59.36 30 59.36V59.37Z",
  fill: "#32D583"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.52023 38.6C2.66023 38.6 0.990234 37.29 0.600234 35.4C0.200234 33.43 -0.00976562 31.4 -0.00976562 29.38C0.000234375 16.31 8.35023 4.84001 20.7702 0.820006C22.8702 0.140006 25.1302 1.29001 25.8102 3.40001C26.4902 5.50001 25.3402 7.76001 23.2302 8.44001C14.1202 11.38 8.00023 19.8 8.00023 29.37C8.00023 30.86 8.15023 32.35 8.45023 33.8C8.89023 35.97 7.49023 38.08 5.33023 38.52C5.06023 38.57 4.79023 38.6 4.53023 38.6H4.52023Z",
  fill: "#32D583"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1178_4838"
}, /*#__PURE__*/React.createElement("rect", {
  width: 60,
  height: 58.74,
  fill: "white",
  transform: "translate(0 0.630005)"
})));

function SvgExecuted(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExecuted);
export default __webpack_public_path__ + "static/media/executed.19e723f7.svg";
export { ForwardRef as ReactComponent };